<template>
    <form @submit.prevent="handleTimelog">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Log Time</p>
            </header>
            <section class="modal-card-body">
                <div>
                    <o-field v-if="!isShort" label="Project" :type="fieldType('project_id')" :message="getError('project_id')">
                        <autocomplete-select
                            :value="projectById(timelog.project_id)"
                            type="project"
                            placeholder="Select a Project"
                            track="id"
                            field-name="full_name"
                            v-model="timelog.project_id" />
                    </o-field>

                    <o-field label="Activity" :type="fieldType('activity_name')" :message="getError('activity_name')">
                        <o-select v-model="timelog.activity_name" placeholder="Select an Activity" expanded>
                            <option :value="null">Not Specified</option>
                            <option
                                v-for="activity in dictionaryEntriesByType('timelog-activity')"
                                :value="activity.id"
                                :key="activity.id">
                                {{ activity.name }}
                            </option>
                        </o-select>
                    </o-field>

                    <div class="block" v-if="timelog.project_id && !isShort">
                        <label>
                            <strong>Focus</strong>
                        </label>

                        <o-tabs v-model="activeTab">
                            <o-tab-item label="Task">
                                <o-field :type="fieldType('activity_id')" :message="getError('activity_id')">
                                    <o-select v-model="taskId" @update:modelValue="changeActivity('task')" placeholder="Select a Task" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                            v-for="task in tasksByProjectId(timelog.project_id)"
                                            :value="task.id"
                                            :key="task.id">
                                            {{ task.title }}
                                        </option>
                                    </o-select>
                                </o-field>
                            </o-tab-item>

                            <o-tab-item label="Service">
                                <o-field :type="fieldType('activity_id')" :message="getError('activity_id')">
                                    <o-select v-model="serviceId" @update:modelValue="changeActivity('project-service')" placeholder="Select a Service" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                            v-for="service in projectServices"
                                            :value="service.id"
                                            :key="service.id">
                                            {{ service.title }}
                                        </option>
                                    </o-select>
                                </o-field>
                            </o-tab-item>
                        </o-tabs >
                    </div>

                    <o-field label="Date" :type="fieldType('date')" :message="getError('date')">
                        <datepicker v-model="timelog.date" :value="timelog.date" />
                    </o-field>

                    <o-field label="Time" :type="fieldType('time')" :message="getError('time')">
                        <o-select v-model="timelog.time" placeholder="Select a Time Amount" expanded>
                            <option :value="null">Not Specified</option>
                            <option
                                    v-for="option in timelogTimeOptions"
                                    :value="option.value"
                                    :key="option.value">
                                {{ option.text }}
                            </option>
                        </o-select>
                    </o-field>

                    <form-error v-if="hasError('time')" error="Time amount is required" />

                    <o-field label="Note" root-class="blocking">
<!--                        <b-quill v-model="timelog.note" :error="getError('note')" />-->
                      <quill-editor v-model:content="timelog.note" :content-type="'html'"/>
                    </o-field>
                </div>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)" :disabled="closable === false">Close</button>
                <button class="button is-primary" v-submit="submitting">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import HandlesForm from '../../mixins/HandlesForm'
    import Datepicker from '../../components/Datepicker'
    import {QuillEditor} from "@vueup/vue-quill";

    export default {
        mixins: [HandlesForm],

        components: {QuillEditor, Datepicker },

        props: {
            timelogProp: {
                required: false,
                type: Object
            },
            projectId: {
                required: false
            },
            closable: {
                required: false,
                default: true
            },
            isShort: {
                required: false,
                default: false
            },
            autoFill: {
                required: false,
                default: false
            }
        },

        mounted () {
          this.timelog.user_id = this.currentUserId
            if (this.timelogProp) {
                this.timelog = _.merge(this.timelog, _.clone(this.timelogProp))
                if(this.autoFill) {
                    this.timelog.activity_name = 44
                    this.timelog.time = 0.25
                }
                if (this.timelog.activity_type === 'task') {
                    this.activeTab = 0
                    this.taskId = this.timelog.activity_id
                } else if (this.timelog.activity_type === 'project-service') {
                    this.activeTab = 1
                    this.serviceId = this.timelog.activity_id
                } else if (this.timelog.activity_type === 'project') {
                    this.activeTab = 1
                }
            } else {
                this.timelog.user_id = this.currentUserId
            }
        },

        data () {
            return {
                taskId: null,
                serviceId: null,
                timelog: {
                    date: moment().format('YYYY-MM-DD'),
                    time: null,
                    user_id: null,
                    project_id: this.projectId,
                    activity_id: null,
                    activity_type: null,
                    activity_name: null,
                    note: '',
                    is_forced: null
                },
                activeTab: 0
            }
        },

        methods: {
            ...mapActions([
                'fetchProjects',
                'fetchTasks',
                'fetchWorkTypes',
                'fetchProjectServices',
                'createOrUpdateTimelog'
            ]),

            handleTimelog() {
                let submit = this.wrapSubmit(this.createOrUpdateTimelog)

                submit(this.timelog)
                    .then(res => {
                        this.$emit('timelog-created')
                        this.successMessage('Time Log was successfull created')
                        this.$parent.$parent.$emit('update:active', false) || this.$parent.$emit('update:active', false)
                        window.location.reload()
                        return res
                    })
                    .catch(res => {
                        if(res.response.status == 405) {
                            this.errorMessage(res.response.data)
                        }
                    })
            },

            changeActivity (name) {
                this.timelog.activity_type = name

                switch (name) {
                    case 'task':
                        this.timelog.activity_id = this.taskId
                        return this.serviceId = null
                    case 'project-service':
                        this.timelog.activity_id = this.serviceId
                        return this.taskId = null
                }
            },
        },

        watch: {
            'timelog.project_id' (project_id) {
                if (project_id && this.projectServicesByProjectId(project_id).length === 0) {
                    this.fetchProjectServices({project_id})
                    this.timelog.reference_id = null
                    this.serviceId = null
                }

                if (project_id && this.tasksByProjectId(project_id).length === 0) {
                    this.fetchTasks({project_id})
                    this.timelog.reference_id = null
                    this.taskId = null
                }
            }
        },

        computed: {
            ...mapGetters([
                'projects', 'projectById', 'projectServicesByProjectId', 'tasksByProjectId',
                'workTypes', 'projectNameById', 'currentUserId',
                'dictionaryEntriesByType', 'timelogTimeOptions',
            ]),

            projectServices() {
                return _.filter(this.projectServicesByProjectId(this.timelog.project_id), service => service.type != 'optional' && (service.status == 'approved' || service.status == 'not_billable'))
            }
        }
    }
</script>
<style>
.blocking{
  display: block !important;
}
</style>
